var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamemakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_light_gamemaker2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.011,2h0L30,16h0c-2.7,0-5.394.005-8.09,0q0,4.056,0,8.112C19.95,26.077,17.982,28.034,16.025,30h0L2,16.008H2ZM10.12,16.008,16.009,21.9q0-2.949,0-5.9c1.96,0,3.92.005,5.88,0-1.949-1.973-3.92-3.925-5.878-5.888Q13.064,13.058,10.12,16.008Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamemakerIcon);
export default __webpack_public_path__ + "static/media/gamemaker-icon.1f8650cb9c732859bbff60bc7295222f.svg";
export { ForwardRef as ReactComponent };